import React, { useState, useEffect } from "react";

import {
  Select,
  Button,
  Input,
  FormLabel,
  FormControl,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  AlertDialogCloseButton,
  useToast,
  useColorModeValue,
  Text,
} from "@chakra-ui/react";

import { axiosPost } from "../../utils/api";
import { ROOT_API } from "utils/constant";
import { API_ROUTES } from "utils/constant";
import { NewsApp } from "utils/constant";
import { get } from "lodash";
import { PORT_SMTP } from "utils/constant";
import { REGEX_HOST } from "utils/constant";
import { ErrorMessage } from "utils/constant";
import { REGEX_EMAIL } from "utils/constant";
import { REGEX_PASSWORD } from "utils/constant";
import { BRAND_MAIL } from "utils/constant";
import useAxios from "axios-hooks";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import isEmpty from "lodash/isEmpty";
import { PortSMTP } from "utils/constant";
import InputController from "components/Form/InputController";
import SelectController from "components/Form/SelectController";
import { PortSMTPOption } from "utils/constant";

const defaultValues = {
  brand: "",
  port: PortSMTP.FES,
  authUserEmail: "",
  authUserPassword: "",
  host: "",
};

const AddSMTPServerDialog = (props) => {
  const { isOpen, onOpen, onClose, fetchData, smtpSetting } = props;
  const cancelRef = React.useRef();
  const toast = useToast();
  const requireMsg = "The field is require";
  const [{ loading: createLoading }, createSMTPServerApi] = useAxios(
    {
      url: ROOT_API + API_ROUTES.SMTP_SERVER,
      method: "post",
    },
    { manual: true }
  );
  const [{ loading: updateLoading }, updateSMTPServerApi] = useAxios(
    {
      url: ROOT_API + API_ROUTES.SMTP_SERVER_UPDATE,
      method: "post",
    },
    { manual: true }
  );

  const schema = yup.object().shape({
    brand: yup.string().required("Vui lòng nhập brand"),
    authUserEmail: yup.string().required("Vui lòng nhập email"),
    // .test('isValidEmail', 'Email không hợp lệ', value => {
    //   return schemaTest.isValidEmail(value);
    // }),
    authUserPassword: yup
      .string()
      .nullable()
      .required("Vui lòng nhập mật khẩu"),
    // .test('isValidPassword', 'Mật khẩu không hợp lệ', value => {
    //   return schemaTest.isValidPassword(value);
    // }),
  });
  const { control, setValue, handleSubmit, reset } = useForm({
    resolver: yupResolver(schema),
    defaultValues,
  });

  useEffect(() => () => reset(), []);

  useEffect(() => {
    if (!isEmpty(smtpSetting)) {
      reset({
        id: smtpSetting?._id,
        brand: smtpSetting?.brand,
        port: PortSMTPOption.find((item) => +item.value === +smtpSetting?.port),
        authUserEmail: smtpSetting?.authUserEmail,
        authUserPassword: smtpSetting?.authUserPassword,
      });
    }
  }, [smtpSetting]);

  const handleSuccess = () => {
    toast({
      title: "Tạo SMTP Server thành công",
      status: "success",
      duration: 9000,
      isClosable: true,
    });
    fetchData?.();
    onClose?.();
  };

  const handleError = (error) => {
    toast({
      title:
        error?.response?.data?.errors?.[0]?.msg ||
        error?.response?.data?.msg ||
        "Tạo SMTP Server không thành công",
      status: "error",
      duration: 9000,
      isClosable: true,
    });
  };

  const onSubmit = (values) => {
    toast.closeAll();

    if (!isEmpty(smtpSetting)) {
      updateSMTPServerApi({
        data: { ...values, port: values?.port.value, id: smtpSetting._id },
      })
        .then((res) => {
          handleSuccess();
        })
        .catch((error) => {
          handleError(error);
        });

      return;
    }

    createSMTPServerApi({
      data: { ...values, port: values?.port.value },
    })
      .then((res) => {
        handleSuccess();
      })
      .catch((error) => {
        handleError(error);
      });
  };

  return (
    <>
      <AlertDialog
        motionPreset="slideInBottom"
        leastDestructiveRef={cancelRef}
        onClose={() => {
          onClose?.();
        }}
        isOpen={isOpen}
        isCentered
      >
        <AlertDialogOverlay />
        <AlertDialogContent>
          <AlertDialogHeader>SMTP Server</AlertDialogHeader>
          <AlertDialogCloseButton />
          <AlertDialogBody>
            <form>
              <InputController
                control={control}
                name="brand"
                label="Brand Name"
                isRequired
              />
              <InputController
                control={control}
                name="host"
                label="Host"
                styleContainer={{ pt: "4" }}
              />
              <SelectController
                styleContainer={{ pt: "4" }}
                control={control}
                defaultValues={PortSMTP.FES}
                options={PortSMTPOption}
                isRequired
                name="port"
                label="Port"
              />
              <InputController
                styleContainer={{ pt: "4" }}
                control={control}
                name="authUserEmail"
                label="User Email"
                isRequired
              />
              <InputController
                styleContainer={{ pt: "4" }}
                control={control}
                name="authUserPassword"
                label="User Password"
                isRequired
              />
            </form>
          </AlertDialogBody>
          <AlertDialogFooter>
            <Button
              ref={cancelRef}
              onClick={() => {
                onClose?.();
              }}
            >
              Hủy
            </Button>
            <Button
              colorScheme="red"
              ml={3}
              isLoading={createLoading || updateLoading}
              onClick={handleSubmit(onSubmit)}
            >
              {isEmpty(smtpSetting) ? "Lưu" : "Cập nhật"}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};

export default AddSMTPServerDialog;
